import { RushRulesDialogContainer } from './RushRulesDialogContainer.tsx';
import { mountDialogUIReactComponent } from '../ui_platform/mountDialogUIReactComponent.tsx';
const renderRushRulesDialog = mountDialogUIReactComponent(RushRulesDialogContainer);
export function showRushRulesDialog(onConfirm) {
    renderRushRulesDialog({
        onConfirm: onConfirm
    });
}
